
<template>
    <div style="padding: 60px;">
        <h1 class="text-center">Set up your loyalty program</h1>
        <p class="text-center description">Complete your setup to start creating lasting relationships with your customers.</p>
        <p class="text-center plan">Your Plan 
            <span class="essential ml-1" v-if="planId == 5">Marketplace</span>
            <span class="essential ml-1" v-else>Essential</span>
        </p>
        <div class="setup-form-wrapper container p-0">
            <div class="progressbar-wrapper" v-bind:class="{ 'py-3': planId == 5 }">
                <h1 class="text-center mb-0" style="font-size: 20px; color: #8B939D;">Account Setup</h1>
                <ul v-if="planId != 5" class="progressbar list-unstyled mx-auto">
                    <li v-bind:class="{ 'done': !subIsActive('/setup/start'), 'active': subIsActive('/setup/start') }">Account Setup</li>
                    <li v-bind:class="{ 'done': !subIsActive('/setup/step-2') && !subIsActive('/setup/start'), 'active': subIsActive('/setup/step-2') }">Loyalty Setup</li>
                    <li v-bind:class="{ 'active': subIsActive('/setup/step-3') }">Privacy Policy, Terms &amp; Conditions</li>
                </ul>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    name: "setup",
    data() {
        return {};
    },
    computed: {
        ...mapState("auth", [
            "hasPasswordUpdated",
            "user",
            "currentStep",
            "planId"
        ])
    },
    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
                return this.$route.path.indexOf(path) === 0; // current path starts with this path string
            });
        }
    },
    mounted() {
        switch (this.currentStep) {
            case "step1":
                this.$router.push({
                    path: "/setup/step-1"
                });
                break;
            case "step2":
                this.$router.push({
                    path: "/setup/step-2"
                });
                break;
            case "step3":
                this.$router.push({
                    path: "/setup/step-3"
                });
                break;
            default:
                this.$router.push({
                    path: "/account/profile"
                });
                break;
        }
    }
};
</script>
<style lang="scss">
</style>
